import { IResponse } from '~/services/api/types';
import { privateAxios } from '../requestsCollection';
import {
  ICeClientRequest,
  ICeEntry,
  ICeEntryCreateRequest,
  ICeEntryUpdateRequest,
  ICeExemption,
  ICeExemptionCategory,
  ICeExemptionCreateRequest,
  ICeExemptionUpdateRequest,
  ICeHistoryMonthlyRecord,
  ICeHistoryMonthRequest,
  ICeMonthlyRecord,
  ICeMonthRequest,
} from './types';

export const getMonthlyRecord = (
  { clinicId, clientId, year, month }: ICeMonthRequest,
  signal?: AbortSignal,
): IResponse<ICeMonthlyRecord> =>
  privateAxios({
    method: 'get',
    url: `clinic/${clinicId}/client/${clientId}/community-engagement/monthly-record`,
    params: { year, month },
    ...(signal && { signal }),
  });

export const getHistoryMonthlyRecord = (
  { clinicId, clientId, medicaidPlanId, year, month }: ICeHistoryMonthRequest,
  signal?: AbortSignal,
): IResponse<ICeHistoryMonthlyRecord> =>
  privateAxios(
    {
      method: 'get',
      url: `clinic/${clinicId}/client/${clientId}/community-engagement/medicaid-plan/${medicaidPlanId}/monthly-record`,
      params: { year, month },
      ...(signal && { signal }),
    },
    'v1/',
  );

const entriesUrl = ({ clinicId, clientId }: ICeClientRequest) =>
  `clinic/${clinicId}/client/${clientId}/community-engagement/entry`;

export const createEntry = (
  client: ICeClientRequest,
  entry: ICeEntryCreateRequest,
): IResponse<ICeEntry> =>
  privateAxios({ method: 'post', url: entriesUrl(client), data: entry }, 'v1/');

export const updateEntry = (
  client: ICeClientRequest,
  entryId: number,
  entry: ICeEntryUpdateRequest,
): IResponse<ICeEntry> =>
  privateAxios({ method: 'put', url: `${entriesUrl(client)}/${entryId}`, data: entry }, 'v1/');

export const archiveEntry = (client: ICeClientRequest, entryId: number): IResponse<void> =>
  privateAxios({ method: 'delete', url: `${entriesUrl(client)}/${entryId}` }, 'v1/');

export const recoverEntry = (client: ICeClientRequest, entryId: number): IResponse<void> =>
  privateAxios({ method: 'post', url: `${entriesUrl(client)}/${entryId}/recover` }, 'v1/');

export const getExemptionCategories = (clinicId: string): IResponse<ICeExemptionCategory[]> =>
  privateAxios(
    { method: 'get', url: `clinic/${clinicId}/exemption-category/available-list` },
    'v1/',
  );

const exemptionsUrl = ({ clinicId, clientId }: ICeClientRequest) =>
  `clinic/${clinicId}/client/${clientId}/community-engagement/exemption`;

export const createExemption = (
  client: ICeClientRequest,
  exemption: ICeExemptionCreateRequest,
): IResponse<ICeExemption> =>
  privateAxios({ method: 'post', url: exemptionsUrl(client), data: exemption }, 'v1/');

export const updateExemption = (
  client: ICeClientRequest,
  exemptionId: number,
  exemption: ICeExemptionUpdateRequest,
): IResponse<ICeExemption> =>
  privateAxios(
    { method: 'put', url: `${exemptionsUrl(client)}/${exemptionId}`, data: exemption },
    'v1/',
  );

export const archiveExemption = (client: ICeClientRequest, exemptionId: number): IResponse<void> =>
  privateAxios({ method: 'delete', url: `${exemptionsUrl(client)}/${exemptionId}` }, 'v1/');

export const recoverExemption = (client: ICeClientRequest, exemptionId: number): IResponse<void> =>
  privateAxios({ method: 'post', url: `${exemptionsUrl(client)}/${exemptionId}/recover` }, 'v1/');

export default {};
